import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import Footer from '../../components/Footer';
import About from '../../components/About';
import MagazineTrack from '../../containers/MagazineTrack';
import Magazine from '../../components/Magazine';
import SEO from '../../components/SEO';
import Config from '../../config';
import ArenaLogo from '../../assets/svg/ArenaLogo';
import Logo from '../../assets/svg/Logo';
import Question from '../../assets/svg/Question';
import styles from './issues.css';

class Issues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
      isOpen: false,
    };
  }

  handleClick = e => {
    this.setState({ x: e.pageX, y: e.pageY, isOpen: true });
  };

  handleAction = bool => {
    this.setState({ isOpen: bool });
  };

  render() {
    const { isOpen, x, y } = this.state;
    const magazineIssues = [...this.props.issues, ...Config.home];

    return (
      <section className={styles.wrapper}>
        <SEO title="All Issues" path="/issues" />
        <header className={styles.header}>
          <a
            className={styles.arenaLogo}
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.are.na/upstatement">
            <ArenaLogo />
            <span className={styles.arenaText}>Visit Our Arena Group!</span>
          </a>
          <div className={styles.logo}>
            <NavLink to="/">
              <Logo />
            </NavLink>
          </div>
          <button onClick={this.handleClick} className={styles.question}>
            <Question />
          </button>
        </header>
        <CSSTransition in={isOpen} timeout={300} classNames={styles} unmountOnExit>
          <About initialX={x} initialY={y} action={this.handleAction} data={Config} />
        </CSSTransition>

        <MagazineTrack>
          {magazineIssues.map(magazine => (
            <Magazine key={magazine.title} {...magazine} />
          ))}
        </MagazineTrack>

        <div className={styles.footer}>
          <Footer />
        </div>
      </section>
    );
  }
}

Issues.propTypes = {
  issues: PropTypes.array,
};

export default Issues;
